import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/WOW14LRG.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>April 14, 2025</ClientTag>
                            <Title>Time to Eat!</Title>
                            <TechniqueTitle>
                            Does the Order in which you Eat your Food Matter?
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Different foods impact blood sugar levels in unique ways. Carbohydrates tend to cause the most significant spikes because they are digested quickly, providing rapid energy. In contrast, proteins and fats digest more slowly, resulting in a more gradual release of energy and a gentler rise in blood sugar.</p>
                    <p className='content'>Pairing carbohydrates with protein and healthy fats can help minimize sharp spikes in blood sugar. Additionally, fiber-rich foods—such as fruits, vegetables, and legumes—slow digestion and absorption, further supporting balanced blood sugar levels.</p>
                     <p className='content'>Research suggests that eating in a particular order —starting with fiber, followed by proteins and fats, and ending with carbohydrates—can help moderate blood sugar responses. However, it’s important not to overthink it. Becoming overly focused on food order can sometimes lead to unnecessary stress or disordered eating patterns. </p>
                     <p className='content'> The best takeaway?</p>
                     <p className='content'>Focus on building balanced meals that naturally include fiber, protein, healthy fats, and carbohydrates. That way, you support stable energy levels—without overcomplicating your plate. </p>

                  
                    <h3 className='my-5'>How Much of each Macronutrient is needed Each Day?</h3>
                    <div>
                      <p className='content'>1. Carbohydrates: 225-325g per day; try to incorporate more complex carbohydrates rather than simple sugars. </p>
                      <p className='content'>2. Proteins: 1g of protein per 1lbs of body weight per day </p>
                      <p className='content'>3. Fats: 44-78g per day; focus primarily on poly unsaturated fatty acids </p>
                      <p className='content'>4. Fibre: 25-38g per day; remember to combine fibre with other nutrients for best absorption! </p>
                      <p className='content'>5. Expert help: Speak with your Naturopathic Doctor to learn your specific macronutrient requirements for health & longevity! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW14" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);
